var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonHouseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "40px",
    viewBox: "0 0 45 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B34BD009-6B4F-4F9D-BF32-B5B7F8FC0F03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 18,
    cy: 18,
    r: 18
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Legal-statements-svg-icons",
    transform: "translate(-73.000000, -112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-123",
    transform: "translate(74.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-78",
    transform: "translate(8.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F8F9FC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    stroke: "#788999"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.875000, 6.750000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-31",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 1.125,
    y: 0,
    width: 31.5,
    height: 30.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1,
    fill: "#C5CCD7",
    fillRule: "evenodd",
    x: 1.125,
    y: 27,
    width: 10.125,
    height: 3.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.125,
    fill: "#C5CCD7",
    fillRule: "evenodd",
    x: 22.5,
    y: 27,
    width: 10.125,
    height: 3.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1,
    fill: "#788999",
    fillRule: "evenodd",
    x: 0,
    y: 0,
    width: 33.75,
    height: 1.125,
    rx: 0.5625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375,20.25 L16.875,20.25 L16.875,20.25 L16.875,30.375 L11.25,30.375 L11.25,21.375 C11.25,20.7536797 11.7536797,20.25 12.375,20.25 Z",
    id: "Rectangle",
    strokeWidth: 1,
    fill: "#C5CCD7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875,20.25 L21.375,20.25 C21.9963203,20.25 22.5,20.7536797 22.5,21.375 L22.5,30.375 L22.5,30.375 L16.875,30.375 L16.875,20.25 Z",
    id: "Rectangle",
    strokeWidth: 1,
    fill: "#C5CCD7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9375,5.625 L24.75,5.625 L24.75,5.625 L24.75,12.375 L21.375,12.375 L21.375,6.1875 C21.375,5.87683983 21.6268398,5.625 21.9375,5.625 Z",
    id: "Rectangle",
    strokeWidth: 1,
    fill: "#E7EAF3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1875,5.625 L9,5.625 L9,5.625 L9,12.375 L5.625,12.375 L5.625,6.1875 C5.625,5.87683983 5.87683983,5.625 6.1875,5.625 Z",
    id: "Rectangle-Copy-2",
    strokeWidth: 1,
    fill: "#E7EAF3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75,5.625 L27.5625,5.625 C27.8731602,5.625 28.125,5.87683983 28.125,6.1875 L28.125,12.375 L28.125,12.375 L24.75,12.375 L24.75,5.625 Z",
    id: "Rectangle",
    strokeWidth: 1,
    fill: "#E7EAF3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,5.625 L11.8125,5.625 C12.1231602,5.625 12.375,5.87683983 12.375,6.1875 L12.375,12.375 L12.375,12.375 L9,12.375 L9,5.625 Z",
    id: "Rectangle-Copy-3",
    strokeWidth: 1,
    fill: "#E7EAF3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5625,12.375 L33.1875,12.375 C33.4981602,12.375 33.75,12.6268398 33.75,12.9375 L33.75,16.3125 C33.75,16.6231602 33.4981602,16.875 33.1875,16.875 L0.5625,16.875 C0.251839828,16.875 3.80448985e-17,16.6231602 0,16.3125 L0,12.9375 C-3.80448985e-17,12.6268398 0.251839828,12.375 0.5625,12.375 Z",
    id: "Rectangle",
    strokeWidth: 1,
    fill: "#C5CCD7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.125,
    fill: "#E7EAF3",
    fillRule: "evenodd",
    x: 25.875,
    y: 20.25,
    width: 3.375,
    height: 3.375,
    rx: 0.5625
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1,
    fill: "#E7EAF3",
    fillRule: "evenodd",
    x: 4.5,
    y: 20.25,
    width: 3.375,
    height: 3.375,
    rx: 0.5625
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.125,
    y1: 24.84375,
    x2: 19.125,
    y2: 25.78125,
    id: "Line-11",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.625,
    y1: 24.84375,
    x2: 14.625,
    y2: 25.78125,
    id: "Line-11",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.875,
    y1: 12,
    x2: 16.875,
    y2: 6.75,
    id: "Line-12",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-32",
    stroke: "#788999",
    strokeWidth: 1.125,
    cx: 26,
    cy: 21,
    r: 17.4375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    stroke: "#788999"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E7EAF3",
    cx: 9.7749998,
    cy: 9.7749998,
    r: 9.7749998
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6499997,8.09268919 L12.6499997,6.8573105 C12.6425841,5.29092632 11.3575773,4.02499992 9.7749998,4.02499992 C8.19242228,4.02499992 6.90741549,5.29092632 6.89999986,6.8573105 L6.89999986,8.09268919 C6.90741549,9.65907337 8.19242228,10.9249998 9.7749998,10.9249998 C11.3575773,10.9249998 12.6425841,9.65907337 12.6499997,8.09268919 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44999993,17.2626632 L3.44999993,14.3556351 C3.46156495,13.1815839 4.85993574,12.2000987 6.69933456,12.0749997 C7.48688441,12.6536395 8.63118483,12.9870268 9.83596077,12.9888432 C11.0407367,12.9906595 12.1875199,12.6607262 12.9793924,12.0844677 C14.7667475,12.2413544 16.0983326,13.2104776 16.0999997,14.3556351 L16.0999997,17.2626632 C14.3072069,18.7875541 12.219194,19.5499996 9.83596077,19.5499996 C7.45272758,19.5499996 5.32407396,18.7875541 3.44999993,17.2626632 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.2249997,
    y1: 16.6749997,
    x2: 13.2249997,
    y2: 18.9749996,
    id: "Line-24",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.32499987,
    y1: 16.6749997,
    x2: 6.32499987,
    y2: 18.9749996,
    id: "Line-24",
    strokeLinecap: "round"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonHouseIcon);
export default __webpack_public_path__ + "static/media/personHouseIcon.86f7a97006a4cfb42ddcd4348e5bbb04.svg";
export { ForwardRef as ReactComponent };